import FAISectionImg, { ImgSrc } from './FAISectionImg';
import mockTableData from './mockData';

import styles from './FAIReportModalContent.module.scss';
import { FAI_REPORT_MODAL_NAMES } from 'config/labels';
interface VesselData {
  [label: string]: string | number | null;
}

export interface TableData {
  lad: VesselData;
  lcx: VesselData;
  rca: VesselData;
}

export interface FAIImageSrc extends ImgSrc {
  histogram: string;
}

interface Props {
  imageSrc?: {
    lad: FAIImageSrc;
    lcx: FAIImageSrc;
    rca: FAIImageSrc;
  };
  tableData?: TableData;
}

export default function FAIReportModalContent({
  imageSrc,
  tableData = mockTableData,
}: Props) {
  if (!imageSrc) return;
  return (
    <div className={styles.section}>
      <div className={styles.section1}>
        <div className={styles.sectionHeader}>
          <div className={styles.header}>
            <span>{FAI_REPORT_MODAL_NAMES.vesselviews}</span>
          </div>
          <div className={styles.divider}></div>
        </div>
        <div className={styles.section1Content}>
          <div className={styles.colorScale}>
            <div className={styles.hu}>
              {`-190HU`}
              <div className={styles.colorBar}></div>
              {`-30HU`}
            </div>
          </div>
          <div className={styles.frame1}>
            <div className={styles.column}>
              <div className={styles.columnHeader}>
                <span>RCA</span>
              </div>
              <div className={styles.columnContent}>
                <div className={styles.content}>
                  <img src={imageSrc?.rca.lesion?.lesion} />
                  <div className={styles.imageColumn}>
                    <img src={imageSrc?.rca.lesion?.proximal} alt="proximal" />
                    <div className={styles.textFrame}>
                      <span>Proximal</span>
                    </div>
                    <img src={imageSrc?.rca.lesion?.maximal} alt="mid" />
                    <div className={styles.textFrame}>
                      <span>Mid</span>
                    </div>
                    <img src={imageSrc?.rca.lesion?.distal} alt="distal" />
                    <div className={styles.textFrame}>
                      <span>Distal</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.columnHeader}>
                <span>LAD</span>
              </div>
              <div className={styles.columnContent}>
                <div className={styles.content}>
                  <img src={imageSrc?.lad.lesion?.lesion} />
                  <div className={styles.imageColumn}>
                    <img src={imageSrc?.lad.lesion?.proximal} alt="proximal" />
                    <div className={styles.textFrame}>
                      <span>Proximal</span>
                    </div>
                    <img src={imageSrc?.lad.lesion?.maximal} alt="mid" />
                    <div className={styles.textFrame}>
                      <span>Mid</span>
                    </div>
                    <img src={imageSrc?.lad.lesion?.distal} alt="distal" />
                    <div className={styles.textFrame}>
                      <span>Distal</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.columnHeader}>
                <span>LCX</span>
              </div>
              <div className={styles.columnContent}>
                <div className={styles.content}>
                  <img src={imageSrc?.lcx.lesion?.lesion} />
                  <div className={styles.imageColumn}>
                    <img src={imageSrc?.lcx.lesion?.proximal} alt="proximal" />
                    <div className={styles.textFrame}>
                      <span>Proximal</span>
                    </div>
                    <img src={imageSrc?.lcx.lesion?.maximal} alt="mid" />
                    <div className={styles.textFrame}>
                      <span>Mid</span>
                    </div>
                    <img src={imageSrc?.lcx.lesion?.distal} alt="distal" />
                    <div className={styles.textFrame}>
                      <span>Distal</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.section2}>
        <div className={styles.sectionHeader}>
          <div className={styles.header}>
            <span>{FAI_REPORT_MODAL_NAMES.huhistogram}</span>
          </div>
          <div className={styles.divider}></div>
        </div>
        <div className={styles.section2Content}>
          <div className={styles.hisArea}>
            <div className={styles.spacer1}></div>
            <div className={styles.chart}>
              <img src={imageSrc?.rca?.histogram} />
            </div>
            <div className={styles.spacer2}></div>
          </div>
          <div className={styles.hisArea}>
            <div className={styles.spacer1}></div>
            <div className={styles.chart}>
              <img src={imageSrc?.lad?.histogram} />
            </div>
            <div className={styles.spacer2}></div>
          </div>
          <div className={styles.hisArea}>
            <div className={styles.spacer1}></div>
            <div className={styles.chart}>
              <img src={imageSrc?.lcx?.histogram} />
            </div>
            <div className={styles.spacer2}></div>
          </div>
        </div>
      </div>
    </div>

    // <>
    // <div className={styles['section1']}>
    //   <div className={`${styles['section-header']}`}>
    //     <span className={styles['header']}>
    //       {FAI_REPORT_MODAL_NAMES.vesselviews}
    //     </span>
    //     <div className={styles['divider']}/>
    //   </div>

    //   <div className={styles['section-content']}>
    //     <div className={styles['color-scale']}>
    //       <div className={styles['hu']}>
    //         {`-190Hu`}
    //         <div className={styles['color-picker-control-bar-hue']}/>
    //         {`-30Hu`}
    //       </div>
    //     </div>
    //     <div className={styles['img-wrapper']}>
    //       <FAISectionImg title="RCA" imageSrc={imageSrc?.rca} />
    //       <FAISectionImg title="LAD" imageSrc={imageSrc?.lad} />
    //       <FAISectionImg title="LCX" imageSrc={imageSrc?.lcx} />
    //     </div>
    //   </div>
    // </div>
    // <div className={styles['section2']}>
    //   <div className={`${styles['section-header']}`}>
    //     <span className={styles['header']}>
    //       {FAI_REPORT_MODAL_NAMES.huhistogram}
    //     </span>
    //     <div className={styles['divider']}/>
    //   </div>
    //   <div className={styles['section-content']}>
    //     {/* <div className={styles['graph-wrapper']}> */}
    //       <div className={styles['stacked-area-chart']}>
    //         <div className={styles['spacer1']}/>
    //         <div className={styles['chart-container']}>
    //           <img
    //             src={imageSrc?.rca?.histogram}
    //           />
    //         </div>
    //         <div className={styles['spacer2']}/>
    //       </div>
    //       <div className={styles['stacked-area-chart']}>
    //         <div className={styles['spacer1']}/>
    //         <div className={styles['chart-container']}>
    //           <img
    //             src={imageSrc?.lad?.histogram}
    //           />
    //         </div>
    //         {/* <div className={styles['spacer2']}/> */}
    //       </div>
    //       <div className={styles['stacked-area-chart']}>
    //         <div className={styles['spacer1']}/>
    //         <div className={styles['chart-container']}>
    //           <img
    //             src={imageSrc?.lcx?.histogram}
    //           />
    //         </div>
    //         {/* <div className={styles['spacer2']}/> */}
    //       </div>
    //     {/* </div> */}
    //   </div>
    // </div>
    // </>
  );
}
